export const NAVIGATION_CARD_PICTURE_MODE = 'contain'
export const NAVIGATION_CARD_PICTURE_CLASSNAME = 'h-[5.75rem] w-[9.125rem]'
